import { call, takeLatest } from "redux-saga/effects";
import {
  PROMOTIONAL_OFFER_ADD,
  PROMOTIONAL_OFFER_UPDATE,
  PROMOTIONAL_OFFER_DELETE,
  PROMOTIONAL_OFFER_LIST,
  PROMOTIONAL_OFFER_VIEW,
  PROMOTIONAL_OFFER_ACTIVE,
} from "../types";
import {
  promotionalOfferAddApi,
  promotionalOfferUpdateApi,
  promotionalOfferDeleteApi,
  promotionalOfferListApi,
  promotionalOfferViewApi,
  promotionalOfferActiveApi,
} from "../apis/promotional-offer-api";

function* promotionalOfferAddWorker(action) {
  try {
    const res = yield call(promotionalOfferAddApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

function* promotionalOfferUpdateWorker(action) {
  try {
    const res = yield call(promotionalOfferUpdateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

function* promotionalOfferDeleteWorker(action) {
  try {
    const res = yield call(promotionalOfferDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

function* promotionalOfferListWorker(action) {
  try {
    const res = yield call(promotionalOfferListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

function* promotionalOfferViewWorker(action) {
  try {
    const res = yield call(promotionalOfferViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

function* promotionalOfferActiveWorker(action) {
  try {
    const res = yield call(promotionalOfferActiveApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* promotionalOfferAddWatcher() {
  yield takeLatest(PROMOTIONAL_OFFER_ADD, promotionalOfferAddWorker);
}
export function* promotionalOfferUpdateWatcher() {
  yield takeLatest(PROMOTIONAL_OFFER_UPDATE, promotionalOfferUpdateWorker);
}
export function* promotionalOfferDeleteWatcher() {
  yield takeLatest(PROMOTIONAL_OFFER_DELETE, promotionalOfferDeleteWorker);
}
export function* promotionalOfferListWatcher() {
  yield takeLatest(PROMOTIONAL_OFFER_LIST, promotionalOfferListWorker);
}
export function* promotionalOfferViewWatcher() {
  yield takeLatest(PROMOTIONAL_OFFER_VIEW, promotionalOfferViewWorker);
}
export function* promotionalOfferActiveWatcher() {
  yield takeLatest(PROMOTIONAL_OFFER_ACTIVE, promotionalOfferActiveWorker);
}
